<template>
  <div
    v-if="minimumAge !== undefined"
    :class="[
      'flex items-center gap-2',
      variant === 'footer'
        ? 'text-xs uppercase text-vp-base-600 ml-0.5 mb-8 tracking-widest'
        : 'text-vp-base-400 flex-row text-sm pt-2'
    ]"
  >
    <div class="flex items-center justify-center w-4 h-4 rounded-full border border-current">
      <span
        v-if="minimumAge > 0"
        class="text-xxs"
      >{{ minimumAge }}</span>
      <iconify-icon
        v-else
        icon="mdi:account-group"
        class="text-xs"
      />
    </div>
    <span>{{ minimumAgeText }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useGettext } from 'vue3-gettext';

const props = defineProps<{
  minimumAge?: number;
  variant?: 'footer' | 'default';
}>();

const { $gettext } = useGettext();

const minimumAgeText = computed(() => {
  const ageText = props.minimumAge ? `${props.minimumAge}+` : 'All Ages';
  return $gettext('This event is %{age}', { age: ageText });
});
</script>
